import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { TweenMax } from 'gsap';
import Colors from '../../globalStyles/variables.json';
import LottieLoading from 'react-lottie';
import animationData from '../../LottieAnimations/bouncing_circles.json';
import style from './style.module.scss'
import { Zoom, Fade, Slide } from 'react-reveal';
import { NoImage } from '../'
import { createItemUrl } from '../../Utils';
import { ItemTypes } from '../../Constants';

class ItemCell extends Component {

    state = {
        hasImageLoaded: false
    }

    componentDidMount() {
        let { photos = [] } = this.props.data
        let { location = '' } = photos[0] || {}
        if (location) {
            var productImage = new Image;
            productImage.onload = () => this.setState({ hasImageLoaded: true })
            productImage.src = location
        } else { this.setState({ hasImageLoaded: true }) }
    }

    onMouseEnter = () => {
        TweenMax.to(this.cell, 0.2, {
            scale: 1.1
        })
    }

    onMouseLeave = () => {
        TweenMax.to(this.cell, 0.2, {
            scale: 1.0
        })
    }

    toggleLoadingImage = () => {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: animationData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return <LottieLoading
            options={defaultOptions}
            height={400}
            width={400} />
    }

    handleCellClick = () => {
        // Previous path setting logic...
        const { itemType = null } = this.props;

        // We need to know the item type in order to open the correct modal.
        if (!itemType) return console.warn('ItemCell -> itemType prop is required... ');
        const itemUrl = createItemUrl(this.props.data.id, itemType);
        if (!itemUrl) return;
        navigate(itemUrl)
    }

    render() {
        const { data = {}, color = Colors.$blue, subTextColor = null } = this.props;
        let { name = 'N/A', details = '', photos = [] } = data;
        let productPhoto = photos.find(p => p.photo_type_id === 1);
        let { location = '' } = productPhoto || {};
        return (
            <div
                onClick={this.handleCellClick}
                ref={e => this.link = e}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
                state={{ index: this.props.index }}
                className={`${style.productWrapper} ${this.themeClass}`}>
                <Slide bottom>
                    <>
                        <div ref={e => this.cell = e} className={`${style.circle} ${this.props.circleClass}`}>
                            {location ? this.state.hasImageLoaded ?
                                <img src={location} /> : this.toggleLoadingImage() : <NoImage />
                            }
                        </div>

                        <div className={style.productName}>
                            <h1 style={{ color: color }}>{name}</h1>
                        </div>
                        <div className={style.descriptionWrapper}>
                            <h1 style={{ color: subTextColor || color }}>{details}</h1>
                        </div>
                    </>
                </Slide>
            </div>
        )
    }
}

ItemCell.propTypes = {
    itemType: PropTypes.oneOf([...Object.values(ItemTypes)])
}


export default ItemCell;